<!-- // NAVIGATION -->
@if (!hideBar) {
  <div class="nav-row">
    <div class="container">
      <nav class="navbar navbar-dark navbar-expand-md" role="navigation">
        <!-- // Brand information and hamburger menu -->
        <a type="button" class="navbar-toggle navbar-toggler collapsed" data-bs-toggle="collapse" data-bs-target="#app-navbar" aria-expanded="false" >
          <i class="fa fa-bars" aria-hidden="true"></i> Menu
        </a>
        @if (authService.isUserLoggedIn()) {
          <div class="nav navbar-nav navbar-right d-md-none">
            <a class="navbar-toggle collapsed" href="#" title="{{'NAVBAR.LOG_OUT' | translate}}" (click)="logOut($event)">
              {{'NAVBAR.LOG_OUT' | translate}}
            </a>
          </div>
        }
        @if (!authService.isUserLoggedIn()) {
          <div class="float-end">
            <ul class="nav navbar-nav navbar-right d-sm-flex d-md-none ms-auto flex-row">
              <li class="">
                <input type="button" class="btn btn-light" value="{{'NAVBAR.LOG_IN' | translate}}" (click)="logIn()"/>
              </li>
            </ul>
          </div>
        }
      <!-- </div> -->
      <!-- // NAVBAR items -->
      <div class="collapse navbar-collapse" id="app-navbar">
        <ul class="nav navbar-nav flex-row gap-5" >
          @if (authService.isUserLoggedIn()  && canShowNav) {
            <li>
              <a tabindex="0" class="ttp-nav-btn" title="{{'NAVBAR.LINK_TITLE_DASHBOARD' | translate}}" (click)="collapse('app-navbar')" [routerLink]="['/dashboard']" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:true}">
                <span>{{'NAVBAR.DASHBOARD' | translate}}</span>
              </a>
            </li>
          }
          @if (!authService.isUserLoggedIn()) {
            <li>
              <div class="dropdown unauthenticated-nav">
                <a href="#" type="button" class="dropdown-toggle ttp-nav-btn" [class]="{'router-link-active': upPage.isActive || nhPage.isActive || shPage.isActive || fastPage.isActive}" data-bs-toggle="dropdown">
                  <span>
                    {{'HOME.PROGRAMS' | translate}}
                  </span>
                </a>
                <ul class="dropdown-menu">
                  <li class="nav-item"><a tabindex="0" target="_blank" rel="noopener noreferrer" href="https://edit.testing.tsa.gov/precheck"><span>TSA PreCheck<sup>&reg;</sup></span><i class="uswds-icon icon-launch" alt="Site Leaving"></i></a></li>
                  <li class="nav-item" ><a tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'UP'}" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:false}" #upPage="routerLinkActive" translate>Global Entry</a></li>
                  <li class="nav-item"><a tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'NH'}" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:false}" #nhPage="routerLinkActive" translate>NEXUS</a></li>
                  <li class="nav-item"><a tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'SH'}" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:false}" #shPage="routerLinkActive" translate>SENTRI</a></li>
                  <li class="nav-item"><a tabindex="0" [routerLink]="['/programs-info']" [queryParams]="{code: 'FAST'}" [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact:false}" #fastPage="routerLinkActive" translate>FAST</a></li>
                </ul>
              </div>
            </li>
          }
          @if (!authService.isUserLoggedIn()) {
            <li>
              <a href="#" class="ttp-nav-btn" data-bs-toggle="modal" data-bs-target="#comparison-wizard"><span>{{'HOME.PROGRAM_COMPARISON_TOOL' | translate}}</span></a>
            </li>
          }
          <li>
            <a tabindex="0" class="ttp-nav-btn" title="{{'NAVBAR.LINK_TITLE_FREQUENTLY_ASKED_QUESTIONS' | translate}}"  href="/faq?lang={{translate.currentLang}}" target="_blank">
              <span>FAQs</span>
            </a>
          </li>
        </ul>
        @if (canShowNav || accountCreation) {
          <ul class="nav navbar-nav navbar-right ms-auto d-none d-md-flex gap-2">
            <li>
              <a tabindex="0" role="link" class="btn btn-light fw-bold d-flex align-items-center" 
                (click)="showMobileInfo()" (keyup.enter)="showMobileInfo()">
                <i class="icon-phone"></i>{{'NAVBAR.GET_APP' | translate}}</a>
            </li>
            @if ((!authService.isUserLoggedIn() && canShowNav)) {
              <li>
                <!-- <p class="navbar-button" [innerHTML]="'NAVBAR.RETURNING_MEMBER' | translate"></p> -->
                <a tabindex="0" class="btn btn-light fw-bold" (click)="logLoginButtonClicked(); logIn()" (keyup.enter)="logLoginButtonClicked(); logIn()">{{'NAVBAR.LOG_IN' | translate}}</a>
              </li>
            }
            @if ((authService.isUserLoggedIn() && canShowNav) || accountCreation) {
              <li class="d-none d-sm-block"  class="nav-item">
                <a tabindex="0" class="ttp-nav-btn" title="{{'NAVBAR.LOG_OUT' | translate}}" (keyup.enter)="logOut($event);" (click)="logOut($event)">
                  <span>{{'NAVBAR.LOG_OUT' | translate}}</span>
                </a>
              </li>
            }
          </ul>
        }
      </div>
    </nav>
  </div>
</div>
}
<security-modal #securityModal [id]="'security-warn'" [route]="'/dashboard'"></security-modal>